// Main Management Page with Tabs (User, Role, Module)
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs, Button, Result } from 'antd';
import { ThemeMainWrapper, ThemeUserManagementTabs } from '../Styles/Theme';
import MobHeader from '../../Components/Header/MobHeader';
import UserManagement from './UserManagement';
import RoleManagement from './RoleManagement';
import ModuleManagement from './ModuleManagement';
import Settings from './Settings';
import { checkModulePermissions, isSuperAdmin } from '../../utils/permissions';

const { TabPane } = Tabs;

const Manage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('1');

  const userPermissions = checkModulePermissions('user-management');
  const rolePermissions = checkModulePermissions('role-management');
  const modulePermissions = checkModulePermissions('module-management');

  const handleTabChange = (key) => {
    setActiveTab(key);
    // Clear URL params when changing tabs
    navigate('/manage');
  };

  return (
    <ThemeMainWrapper>
      <MobHeader />
      <ThemeUserManagementTabs
        activeKey={activeTab}
        onChange={handleTabChange}
        type="card"
        size="large"
      >
        <TabPane
          tab="User Management"
          key="1"
          disabled={!userPermissions.authorized}
        >
          {userPermissions.authorized ? (
            <UserManagement />
          ) : (
            <Result
              status="403"
              title="403"
              subTitle="Sorry, you are not authorized to access this page."
              extra={
                <Button type="primary" onClick={() => navigate('/')}>
                  Back Home
                </Button>
              }
            />
          )}
        </TabPane>

          <TabPane
            tab="Role Management"
            key="2"
            disabled={!rolePermissions.authorized}
          >
            {rolePermissions.authorized ? (
              <RoleManagement />
            ) : (
              <Result
                status="403"
                title="403"
                subTitle="Sorry, you are not authorized to access this page."
                extra={
                  <Button type="primary" onClick={() => navigate('/')}>
                    Back Home
                  </Button>
                }
              />
            )}
          </TabPane>

        <TabPane tab="Modules" key="3" disabled={!modulePermissions.authorized}>
          {modulePermissions.authorized ? (
            <ModuleManagement />
          ) : (
            <Result
              status="403"
              title="403"
              subTitle="Sorry, you are not authorized to access this page."
              extra={
                <Button type="primary" onClick={() => navigate('/')}>
                  Back Home
                </Button>
              }
            />
          )}
        </TabPane>

        {isSuperAdmin() && (
          <TabPane tab="Settings" key="4">
            <Settings />
          </TabPane>
        )}
      </ThemeUserManagementTabs>
    </ThemeMainWrapper>
  );
};

export default Manage;

